var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8305 6.43666C24.0598 5.28873 22.8415 3.46512 22.4622 1.39461C22.3753 0.934804 22.3321 0.467878 22.333 0H16.811V22.0477C16.7183 24.5345 14.6656 26.5016 12.1677 26.4976C11.4169 26.4986 10.6774 26.3159 10.0141 25.9655C8.12275 24.9783 7.15205 22.8325 7.66246 20.767C8.17287 18.7015 10.0326 17.2499 12.1677 17.2503C12.6327 17.2511 13.0947 17.3234 13.5375 17.4648V11.8477C8.88946 11.2127 4.40968 13.8319 2.69963 18.1842C0.989581 22.5365 2.4943 27.4894 6.33996 30.1665C9.44232 32.3328 13.4968 32.5998 16.8584 30.859C20.2199 29.1183 22.3302 25.659 22.333 21.8847V10.6934C24.5659 12.2957 27.2482 13.1574 30 13.1565V7.65534C28.5212 7.65916 27.0729 7.23585 25.8305 6.43666Z",
    fill: "var(--template-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.9d18ae4ac1feffffae7b97e07d9c16fa.svg";
export { ForwardRef as ReactComponent };